module.exports = __webpack_public_path__ + "static/media/iphone-nerdify.544266c3.png";